import React, { useState, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import { translations } from './Translation';

import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({ iconRetinaUrl: markerIcon2x, iconUrl: markerIcon, shadowUrl: markerShadow });

function Sidebar({ isOpen, shop }) {
  const [language, setLanguage] = useState(localStorage.getItem('elitecut_lang') || 'en');
  const t = translations[language] || translations.en;

  useEffect(() => {
    const handleStorage = () => setLanguage(localStorage.getItem('elitecut_lang') || 'en');
    window.addEventListener('storage', handleStorage);
    return () => window.removeEventListener('storage', handleStorage);
  }, []);

  if (!isOpen || !shop) return null;

  const schedule = shop.schedule || {};
  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const displayAddress = shop.address || shop.location || t.notSet;

  return (
    <div className="right-column shop-sidebar" style={{ flex: '1', minWidth: '280px', maxWidth: '350px', marginLeft: 'auto' }}>
      <h3>{t.shopLoc}</h3>
      <p style={{ color: '#64748b', marginBottom: '15px', fontSize: '14px' }}>{displayAddress}</p>

      {shop.lat && shop.lng ? (
        <div style={{ width: '100%', height: '220px', borderRadius: '12px', overflow: 'hidden', border: '1px solid #e2e8f0', marginBottom: '25px', zIndex: 0, position: 'relative' }}>
          <MapContainer center={[shop.lat, shop.lng]} zoom={15} style={{ width: '100%', height: '100%' }}>
            <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
            <Marker position={[shop.lat, shop.lng]}>
              <Popup>{shop.shopName}</Popup>
            </Marker>
          </MapContainer>
        </div>
      ) : (
        <div style={{ width: '100%', height: '220px', borderRadius: '12px', background: '#f1f5f9', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '25px', color: '#94a3b8', fontSize: '13px' }}>
          {t.mapNotSet}
        </div>
      )}

      <h3>{t.openHours}</h3>
      <div className="sidebar-schedule" style={{ background: 'white', padding: '20px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
        {days.map(day => {
          const dayData = schedule[day];
          return (
            <div key={day} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f1f5f9' }}>
              <span style={{ fontWeight: '600', color: '#0f172a', fontSize: '14px' }}>{day}</span>
              <span style={{ color: dayData?.closed ? '#ef4444' : '#64748b', fontSize: '14px' }}>
                {!dayData ? t.notSet : dayData.closed ? t.closed : `${dayData.open} - ${dayData.close}`}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Sidebar;